/// <reference path="../../typings/tsd.d.ts" />
module warsApp.models {
    declare var notificationSubscriptionActionSelf: NotificationSubscriptionsModel;

    export class NotificationSubscriptionsModel {
        public emailConfigurations: Wars.Domain.Model.Dtos.EmailConfigurationDto[];
        public userNotifications: Wars.Domain.Model.Dtos.UserEmailNotificationDto[];
        public userMappedEmailConfigurations: any;
        public tinyMceOptions: any;

        constructor(
            private scope: angular.IScope,
            private growlService: angular.growl.IGrowlService,
            private userService: services.UserService,
            private emailService: services.EmailService)
        {
            notificationSubscriptionActionSelf = this;
            notificationSubscriptionActionSelf.userMappedEmailConfigurations = [];
            var currentUser = userService.getCurrentUser();
            emailService.getUserEmailNotifications()
                .then((notifications) => {
                    notificationSubscriptionActionSelf.userNotifications = notifications;
                    emailService.getAllEmailConfigurationApplicableForCurrentUser()
                        .then((emailConfigs) => {
                            notificationSubscriptionActionSelf.emailConfigurations = emailConfigs;
                            notificationSubscriptionActionSelf.emailConfigurations.forEach(emailConfigurationDto => {
                                var emailConfiguration = Enumerable.from(notificationSubscriptionActionSelf.userNotifications).firstOrDefault(userEmailNotificationDto => userEmailNotificationDto.uniqueIdentifier === emailConfigurationDto.uniqueIdentifier);
                                var userMappedEmailConfiguration = {
                                    id: emailConfiguration !== null && emailConfiguration !== undefined ? emailConfiguration.id : null,
                                    userId: currentUser.userId,
                                    uniqueIdentifier: emailConfigurationDto.uniqueIdentifier,
                                    emailConfigurationId: emailConfigurationDto.id,
                                    recieveNotification: emailConfiguration === null || emailConfiguration === undefined,
                                    emailName: emailConfigurationDto.name,
                                    emailSubject: emailConfigurationDto.emailSubject.replace(/<(?:.|\n)*?>/gm, ''),
                                    emailText: emailConfigurationDto.emailText//,
                                    //processName: i.myProcessConfiguration !== null ? i.myProcessConfiguration.myProcessType.name : ''
                                };
                                notificationSubscriptionActionSelf.userMappedEmailConfigurations.push(userMappedEmailConfiguration);
                            });
                        });
                });
            notificationSubscriptionActionSelf.tinyMceOptions = {
                format: 'raw',
                menubar: false,
                statusbar: false,
                toolbar: false,
                height: 100,
                plugins: "noneditable",
                readonly: 1,
                content_css: "content/mce.css"
            };
        }

        public updateNotificationSubscription(userMappedConfiguration: any) {
            if (userMappedConfiguration.id !== null) {
                var foundUserEmailNotification = Enumerable.from(notificationSubscriptionActionSelf.userNotifications).first(i => i.id === userMappedConfiguration.id);
                this.emailService.deleteUserEmailNotification(foundUserEmailNotification)
                    .then(() => {
                        notificationSubscriptionActionSelf.userNotifications = Enumerable.from(notificationSubscriptionActionSelf.userNotifications).where(i => i.id !== userMappedConfiguration.id).toArray();
                        userMappedConfiguration.id = null;
                    });
            } else {
                var userNotification = {
                    uniqueIdentifier: userMappedConfiguration.uniqueIdentifier
                }
                this.emailService.createUserEmailNotification(userNotification)
                    .then((userEmailNotification) => {
                        userMappedConfiguration.id = userEmailNotification.id;
                        notificationSubscriptionActionSelf.userNotifications.push(userEmailNotification);
                    });
            }
        }
    }
}